import React from 'react';
import NoResults from './noResults/NoResults';


class ErrorBoundary extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            errorInfo: null
        };
    }

    componentDidCatch(error, errorInfo) {

        this.setState({
            error: error,
            errorInfo: errorInfo
        });

    }

    render() {
        if (this.state.errorInfo) {

            return (
                <NoResults message='Something went wrong.'>
                    <details style={{ whiteSpace: 'pre-wrap' }}>
                        {this.state.error && this.state.error.toString()}
                        <br />
                        {this.state.errorInfo.componentStack}
                    </details>
                </NoResults>
            );
        }

        return this.props.children;
    }
}


export default ErrorBoundary;
